module.exports = __webpack_public_path__ + "img/Mockup_Lubkin-2.22634c76.png";